import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { sendnewrequest, getOpenRequest, getdisputemessages, getdisputerepliesmessages } from '../../Apis';

export const AllSupportRequest = createAsyncThunk('AllSupportRequest', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await getOpenRequest(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


export const RaiseSupportTicket = createAsyncThunk('RaiseSupportTicket', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await sendnewrequest(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const DisputesReplies = createAsyncThunk('disputereplies', async ({ token, formData }, { rejectWithValue }) => {
    try {

        const response = await getdisputemessages(token, formData);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const DisputesRepliesmessage = createAsyncThunk('disputerepliesmessage', async ({ token, formData }, { rejectWithValue }) => {
    try {

        const response = await getdisputerepliesmessages({ token, formData });
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


const supportSlice = createSlice({
    name: 'support',
    initialState: {
        error: null,
        success: false,
        data: [],
        data2: [],
        ticket_info: {},
        hasMore: true, // Track if more data is available
        loading: false, // Track loading state
    },
    reducers: {
        clearSupportStatus: state => {
            state.success = false;
            state.error = null;
        },
        resetPagination: (state) => {
            state.data2 = [];
            state.hasMore = true;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(RaiseSupportTicket.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(RaiseSupportTicket.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
            })
            .addCase(RaiseSupportTicket.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(AllSupportRequest.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(AllSupportRequest.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(AllSupportRequest.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(DisputesReplies.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(DisputesReplies.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                if (action.payload.data.length === 0) {
                    state.hasMore = false;
                } else {
                    state.data2 = [...state.data2, ...action.payload.data.data]; // Append new data
                }
                state.ticket_info = action.payload.data.ticket_info;
            })
            .addCase(DisputesReplies.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(DisputesRepliesmessage.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(DisputesRepliesmessage.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
            })
            .addCase(DisputesRepliesmessage.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })

    },

});
export const { clearSupportStatus, resetPagination } = supportSlice.actions;
export default supportSlice.reducer;

